// ═══════════════════════════════════════════════════════════════════════════════
// Employer — floating bottom review bar (X reject / Tick approve)
// Used on task review and settlement review pages.
// ═══════════════════════════════════════════════════════════════════════════════

import { useLanguage } from '../../contexts/LanguageContext';
import { FIXED_ABOVE_BOTTOM_NAV } from '../../lib/layoutChrome';
import { portalToBody } from '../../lib/portalToBody';
import { AppButton } from '../ui/AppButton';

type EmployerFloatingReviewBarProps = {
  onReject: () => void;
  onApprove: () => void;
  disabled?: boolean;
  rejectAriaLabel: string;
  approveAriaLabel: string;
};

export const EmployerFloatingReviewBar = ({
  onReject,
  onApprove,
  disabled = false,
  rejectAriaLabel,
  approveAriaLabel,
}: EmployerFloatingReviewBarProps) => {
  const { t } = useLanguage();

  return portalToBody(
    <div
      className={`${FIXED_ABOVE_BOTTOM_NAV} border-t border-gray-200 bg-white p-4 shadow-lg dark:border-gray-700 dark:bg-gray-900`}
      role="region"
      aria-label={t('task.review.reviewPrompt')}
    >
      <p className="mb-2 text-center text-sm font-semibold text-gray-700 dark:text-gray-200">
        {t('task.review.reviewPrompt')}
      </p>
      <div className="mx-auto flex max-w-lg gap-3">
        <AppButton
          variant="danger"
          size="lg"
          onClick={onReject}
          disabled={disabled}
          aria-label={rejectAriaLabel}
          className="flex-1 shadow-md"
        >
          <svg className="h-7 w-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </AppButton>
        <AppButton
          variant="primary"
          size="lg"
          onClick={onApprove}
          disabled={disabled}
          aria-label={approveAriaLabel}
          className="flex-1 shadow-md"
        >
          <svg className="h-7 w-7" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M5 13l4 4L19 7" />
          </svg>
        </AppButton>
      </div>
    </div>,
  );
};
